/**
 * 项目管理
 */
const RulesRegRouter = {
  path: '/rules',
  component: () => import('@/views/layout'),
  redirect: '/rules/journal/list',
  alwaysShow: true,
  meta: {
    title: '办公管理',
    icon: require('@/assets/slider/rules.png')
  },
  children: [
    {
      path: 'journal/list',
      name: 'rules_journal',
      component: () => import('@/views/rules_regulations/other_rules/journal'),
      meta: {
        title: '日志',
        keepAlive: true
      }
    },
    {
      path: 'approval/list',
      name: 'rules_approval',
      component: () => import('@/views/rules_regulations/other_rules/approval'),
      meta: {
        title: '工作待办',
        keepAlive: true
      }
    },
    {
      path: 'kpi',
      name: 'rules_kpi',
      component: () => import('@/views/rules_regulations/other_rules/kpi'),
      meta: {
        title: '绩效考核'
      },
      children: [
        {
          path: 'kpiach/list',
          name: 'kpiachie',
          component: () => import('@/views/rules_regulations/other_rules/kpi/achievements'),
          meta: {
            title: '绩效',
            keepAlive: true
          }
        },
        {
          path: 'appraisal/list',
          name: 'appraisal',
          component: () => import('@/views/rules_regulations/other_rules/kpi/appraisal'),
          meta: {
            title: '考核',
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/archives',
      redirect: 'contract/list',
      component: () => import('@/views/rules_regulations/archives'),
      meta: {
        title: '档案管理',
        keepAlive: true
      },
      children: [
        {
          path: 'contract/list',
          name: 'rules_contract',
          component: () => import('@/views/rules_regulations/other_rules/contract'),
          meta: {
            title: '合同',
            keepAlive: true
          }
        },
        {
          path: 'system',
          component: () => import('@/views/rules_regulations/index'),
          redirect: '/rules/system/general/list',
          meta: {
            title: '规章制度'
          },
          children: [
            {
              path: 'approval/list',
              name: 'system_approval',
              component: () => import('@/views/rules_regulations/system_approval'),
              meta: {
                title: '制度审批',
                keepAlive: true
              }
            },
            {
              path: 'general/list',
              name: 'general_provisions',
              component: () => import('@/views/rules_regulations/general_provisions'),
              meta: {
                title: '总则',
                keepAlive: true
              }
            },
            {
              path: 'admin/list',
              name: 'admin_personnel',
              component: () => import('@/views/rules_regulations/admin_personnel'),
              meta: {
                title: '行政人事',
                keepAlive: true
              }
            },
            {
              path: 'finance/list',
              name: 'finance',
              component: () => import('@/views/rules_regulations/finance'),
              meta: {
                title: '财务',
                keepAlive: true
              }
            },
            {
              path: 'market/list',
              name: 'market',
              component: () => import('@/views/rules_regulations/market'),
              meta: {
                title: '市场',
                keepAlive: true
              }
            },
            {
              path: 'operate/list',
              name: 'operate',
              component: () => import('@/views/rules_regulations/operate'),
              meta: {
                title: '运营',
                keepAlive: true
              }
            },
            {
              path: 'achievements/list',
              name: 'achievements',
              component: () => import('@/views/rules_regulations/achievements'),
              meta: {
                title: '绩效',
                keepAlive: true
              }
            }
          ]
        },
        {
          path: 'internalfile/list',
          name: 'InternalFile',
          component: () => import('@/views/rules_regulations/InternalFile'),
          meta: {
            title: '公司文件',
            keepAlive: true
          }
        },
        {
          path: 'meeting/list',
          name: 'meeting',
          component: () => import('@/views/rules_regulations/MeetingMinutes'),
          meta: {
            title: '会议纪要',
            keepAlive: true
          }
        }
      ]

    },
    {
      path: 'bonus_penalty/list',
      name: 'bonusPenalty',
      component: () => import('@/views/rules_regulations/bonus_penalty/index'),
      meta: {
        title: '奖惩考核',
        keepAlive: true
      }
    },

    {
      path: 'openplan/list',
      name: 'openPlan',
      component: () => import('@/views/rules_regulations/openPlan'),
      meta: {
        title: '公开计划',
        keepAlive: true
      }
    }
  ]
}
// 子元素
const RulesRegRouterDesc = {
  path: '/rules',
  component: () => import('@/views/layout'),
  redirect: '/rules/system/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'system/general/add',
      name: 'addsystem',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '添加规章制度'
      }
    },
    {
      path: 'system/admin/add',
      name: 'addadmin',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '添加规章制度'
      }
    },
    {
      path: 'system/finance/add',
      name: 'addfinance',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '添加规章制度'
      }
    },
    {
      path: 'system/market/add',
      name: 'addmarket',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '添加规章制度'
      }
    },
    {
      path: 'system/operate/add',
      name: 'addoperate',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '添加规章制度'
      }
    },
    {
      path: 'kpi/kpiach/add',
      name: 'addkpi',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '添加绩效考核'
      }
    },
    // 编辑

    {
      path: 'system/general/edit/:id',
      name: 'editsystem',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '编辑规章制度'
      }
    },
    {
      path: 'system/admin/edit/:id',
      name: 'editadmin',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '编辑规章制度'
      }
    },
    {
      path: 'system/finance/edit/:id',
      name: 'editfinance',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '编辑规章制度'
      }
    },
    {
      path: 'system/market/edit/:id',
      name: 'editmarket',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '编辑规章制度'
      }
    },
    {
      path: 'system/operate/edit/:id',
      name: 'editoperate',
      hidden: true,
      component: () => import('@/views/rules_regulations/changerules'),
      meta: {
        title: '编辑规章制度'
      }
    },
    // 查看文檔
    {
      path: 'system/approval/show/:id',
      name: 'showruledesc',
      hidden: true,
      component: () => import('@/views/rules_regulations/system_approval/pages/rule_desc'),
      meta: {
        title: '撤销详情'
      }
    },
    {
      path: 'system/general/show/:id',
      name: 'showsystem',
      hidden: true,
      component: () => import('@/views/rules_regulations/showrules'),
      meta: {
        title: '查看文档'
      }
    },
    {
      path: 'system/admin/show/:id',
      name: 'showadmin',
      hidden: true,
      component: () => import('@/views/rules_regulations/showrules'),
      meta: {
        title: '查看文档'
      }
    },
    {
      path: 'system/finance/show/:id',
      name: 'showfinance',
      hidden: true,
      component: () => import('@/views/rules_regulations/showrules'),
      meta: {
        title: '查看文档'
      }
    },
    {
      path: 'system/market/show/:id',
      name: 'showmarket',
      hidden: true,
      component: () => import('@/views/rules_regulations/showrules'),
      meta: {
        title: '查看文档'
      }
    },
    {
      path: 'system/operate/show/:id',
      name: 'showoperate',
      hidden: true,
      component: () => import('@/views/rules_regulations/showrules'),
      meta: {
        title: '查看文档'
      }
    },
    // 绩效的
    {
      path: 'kpi/kpiach/show/:id',
      name: 'showkpiach',
      hidden: true,
      component: () => import('@/views/rules_regulations/showrules'),
      meta: {
        title: '查看文档'
      }
    },

    // 日志查看详情
    {
      path: 'journal/detail/:id',
      name: 'logs_desc',
      hidden: true,
      component: () => import('@/views/rules_regulations/other_rules/journal/pages/logs_desc'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'journal/add/:type',
      name: 'logs_add',
      hidden: true,
      component: () => import('@/views/rules_regulations/other_rules/journal/pages/logs_change'),
      meta: {
        title: '添加日报'
      }
    },

    {
      path: 'kpi/appraisal/personneleditor/:id',
      name: 'personneleditor',
      hidden: true,
      component: () => import('@/views/rules_regulations/other_rules/kpi/personneleditor'),
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'kpi/appraisal/officeeditor/:id/:companyId/:type',
      name: 'officeeditor',
      hidden: true,
      component: () => import('@/views/rules_regulations/other_rules/kpi/officeeditor'),
      meta: {
        title: '编辑'
      }
    },
    // 合同模块
    {
      path: 'contract/add',
      name: 'addcontract',
      hidden: true,
      component: () => import('@/views/rules_regulations/other_rules/contract/change'),
      meta: {
        title: '编辑'
      }
    },
    {
      path: 'contract/desc/:id',
      name: 'desccontract',
      hidden: true,
      component: () => import('@/views/rules_regulations/other_rules/contract/show'),
      meta: {
        title: '编辑'
      }
    },
    // 公开计划
    {
      path: 'openplan/detail/:id/:type',
      name: 'planInfo',
      hidden: true,
      component: () => import('@/views/rules_regulations/openPlan/planInfo'),
      meta: {
        title: '详情'
      }
    }

  ]
}

export { RulesRegRouterDesc, RulesRegRouter }
